import assign from "lodash/fp/assign";
import apis from "../../core/apis.js";

class PromotionResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  search(query = "", params) {
    return this.$resource(apis.promotion + "autocomplete/").get(
      assign(params, { query })
    );
  }

  getAll(options) {
    return this.$resource(apis.promotion).get(options);
  }

  get(id) {
    return this.$resource(apis.promotion + id).get();
  }

  post(item) {
    return this.$resource(apis.promotion).save(item);
  }

  update(id, item) {
    return this.$resource(apis.promotion + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default PromotionResource;



// WEBPACK FOOTER //
// ./src/resources/promotion/promotion.resource.js